<!-- 我的优惠券 -->
<template>
  <div id="coupon">
    <van-nav-bar title="优惠券领取" left-arrow @click-left="onClickLeft" />
    <div class="tab-panel-item tab-active" v-for="(item,index) in couponList" :key="index">
      <a href="javascript:;" class="jq22-flex">
        <div class="jq22-price-nub">
          <div class="jq22-digit">
            <h2 v-if="item.type=='1'">
              <em>￥</em>{{item.dec_price}}
            </h2>
            <h2 v-else>
              {{item.dec_percent}}<em>折</em>
            </h2>
          </div>
          <div class="jq22-full">
            <p>满{{item.max_price}}元可用</p>
          </div>
        </div>
        <div class="jq22-flex-box">
          <h2>{{item.title}}</h2>
          <h3>{{item.start_time*1000|dayjs}}至{{item.end_time*1000|dayjs}}</h3>
          <h3>剩余{{item.num - item.has_draw}}张</h3>
          <button @click="receiveCoupon(item.id)">领取</button>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import {getCouponList,receiveCoupon} from '@/api/api-coupon.js'

export default {
  components: {},
  data() {
    return {
      couponList:[]
    };
  },
  computed: {},
  watch: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getCouponList(){
      getCouponList().then(res=>{
        this.couponList = res
      })
    },
    receiveCoupon(id){
      const data = {
        'id':id
      }
      receiveCoupon(data).then(res=>{
        if (res!==false) {
          Toast.success('领取成功');
        }
      })
    }
  },
  created() {
    this.getCouponList()
  },
  mounted() {},
};
</script>
<style lang='less' scoped>
@import './index.less';
</style>